import {useEffect, useState, type ReactNode} from "react";
import {createPortal} from "react-dom";
import {useI18n} from "./I18nProvider";

type Props = {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
};

export function AccountModal({open, title, onClose, children, footer}: Props) {
  const {t} = useI18n();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if(!open) return;
    function onKey(e: KeyboardEvent) {
      if(e.key === "Escape") onClose();
    }
    document.addEventListener("keydown", onKey);
    document.body.classList.add("noscroll");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.classList.remove("noscroll");
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);
  if(!mounted || !open) return null;
  return createPortal(
    <div className="cc-accountModal" role="dialog" aria-modal="true" aria-labelledby="cc-accountModalTitle">
      <button type="button" className="cc-accountModal__backdrop anim" aria-label={t("Close")} onClick={onClose} />
      <div className="cc-accountModal__panel">
        <header className="cc-accountModal__head">
          <h2 id="cc-accountModalTitle" className="cc-accountModal__title">{title}</h2>
          <button type="button" className="cc-accountModal__close anim" onClick={onClose} aria-label={t("Close")}>
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </header>
        <div className="cc-accountModal__body">{children}</div>
        {footer ? <footer className="cc-accountModal__foot">{footer}</footer> : null}
      </div>
    </div>,
    document.body
  );
}
